import {
  type CommonTranslationFunction,
  useAutoneTranslation,
} from '@autone/translations';
import { fReadableCurrency } from '@autone/utils';
import { type FC } from 'react';

import { ProductInfo } from '../ProductInfo';

const getUnformattedProductPriceInfo = ({
  retailPrice,
  wholesalePrice,
  currency,
  common,
}: {
  retailPrice?: number | null;
  wholesalePrice?: number | null;
  currency: string;
  common: CommonTranslationFunction;
}) => {
  return `${retailPrice ? fReadableCurrency(retailPrice, currency) : common('na')} ${common('product-price.retail-price')} · ${wholesalePrice ? fReadableCurrency(wholesalePrice, currency) : common('na')} ${common('product-price.wholesale-price')}`;
};

const ProductPriceInfo: FC<{
  retailPrice?: number | null;
  wholesalePrice?: number | null;
  currency: string;
  className?: string;
}> = ({ retailPrice, wholesalePrice, currency, className }) => {
  const { common } = useAutoneTranslation();
  const text = getUnformattedProductPriceInfo({
    retailPrice,
    wholesalePrice,
    currency,
    common,
  });
  return <ProductInfo.SubTitle className={className} value={text} />;
};
export default ProductPriceInfo;
